module.exports = __webpack_public_path__ + "img/dashboard-asset.42814556.svg";